import { memo } from "react";
import Icon from "components/Elements/Icon/Icon";
import { useContent } from "contexts/contentContext/contentContext";
import CustomPopup from "components/Pages/Inbox/Popups/CustomPopup";
import Button from "components/Elements/Button/Button";
import useQueryParamDropdown, {
  QueryParamDropdownListT,
} from "./helpers/useQueryParamDropdown";

import "./styles.scss";

const CONTEXT_MENU_TOP_OFFSET = 50;

type QueryParamDropdownFilterPropsT = {
  queryParams: QueryParamDropdownListT;
  asIcon?: boolean;
  titleKey?: string;
  selectedCount: number;
  onChange?: (value: QueryParamDropdownListT) => void;
  counters?: { for: string; counters: { [key: string]: number } };
};

const QueryParamDropdownFilter = memo(
  (props: QueryParamDropdownFilterPropsT) => {
    const {
      queryParams,
      asIcon,
      titleKey = "filter-title",
      selectedCount,
      onChange,
      counters,
    } = props;
    const { getTextByKey } = useContent();
    const {
      clear,
      apply,
      select,
      selected,
      toggleShowDropdown,
      showDropdown,
      dropdownRef,
    } = useQueryParamDropdown(queryParams, onChange);

    return (
      <div
        className={`filter-status-wrapper ${
          asIcon ? "filter-status-wrapper-as-icon" : ""
        }`}
        ref={dropdownRef}
      >
        <div
          className={`filter-status-button ${
            !!selectedCount ? "blue-border" : ""
          }`}
          onClick={toggleShowDropdown}
        >
          {!!selectedCount && <div className="counter">{selectedCount}</div>}
          <Icon name="newInbox/filter" darkGray large alt="filter" />
          {!asIcon && <span>{getTextByKey("filter-status")}</span>}
        </div>
        <CustomPopup
          showState={showDropdown}
          topPosition={CONTEXT_MENU_TOP_OFFSET}
        >
          <div className="checkbox-list-dropdown">
            <Icon
              name="x"
              large
              gray
              onClick={() => toggleShowDropdown(false)}
              iconClass="close-icon"
              alt="close"
            />
            <h1>{getTextByKey(titleKey)}</h1>
            <div className="filter-status-scroll-constraint">
              <hr />
              {Object.keys(queryParams).map((section) => (
                <div key={section}>
                  <h2>{getTextByKey(`filter-section-${section}`)}</h2>
                  <ul>
                    {queryParams[section]?.map((parameter) => {
                      const name =
                        typeof parameter === "string"
                          ? parameter
                          : parameter.name;

                      const type =
                        typeof parameter === "string"
                          ? "checkbox"
                          : parameter.type;

                      return (
                        <li
                          key={name}
                          onClick={() => select(section, name, type)}
                        >
                          <div
                            className={`checkbox-wrapper ${
                              selected[section]?.includes(name)
                                ? "selected"
                                : ""
                            }`}
                          >
                            {selected[section]?.includes(name) && (
                              <Icon
                                name="newInbox/mark"
                                iconClass="mark-icon"
                                blue
                              />
                            )}
                          </div>
                          <span className="filter-row">
                            <span>{getTextByKey(`${name}`)}</span>
                            <span>
                              {counters?.for === section
                                ? counters.counters?.[name + "-" + section]
                                : ""}
                            </span>
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ))}
            </div>
            <div className="buttons">
              <Button onClick={apply}>{getTextByKey("filter-apply")}</Button>
              <button className="clear-button" onClick={clear}>
                {getTextByKey("filter-clear-all")}
              </button>
            </div>
          </div>
        </CustomPopup>
      </div>
    );
  }
);

export default QueryParamDropdownFilter;
